module.exports = __webpack_public_path__ + "baroquescript-webfont.444742ddee138f71aae7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/baroquescript-webfont.svg
// module id = 571
// module chunks = 1